Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "AddressInput4153327387",
  {"root":"AddressInput4153327387--root","option":"AddressInput4153327387--option","iconWrapper":"AddressInput4153327387--iconWrapper","icon":"AddressInput4153327387--icon","optionContent":"AddressInput4153327387--optionContent"},
  ".AddressInput4153327387--option{display:flex}.AddressInput4153327387--iconWrapper{display:flex;align-items:center;padding:0 6px}.AddressInput4153327387--optionContent{flex:1}",
  5,
  "AddressInput4153327387"
);
__webpack_require__.stylable.$.register(exports.default)
